import { render, staticRenderFns } from "./CertificationDocumentViewer.vue?vue&type=template&id=7d8fe51b&scoped=true&"
import script from "./CertificationDocumentViewer.vue?vue&type=script&lang=js&"
export * from "./CertificationDocumentViewer.vue?vue&type=script&lang=js&"
import style0 from "./CertificationDocumentViewer.vue?vue&type=style&index=0&id=7d8fe51b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8fe51b",
  null
  
)

export default component.exports